module.exports = __webpack_public_path__ + "static/media/seed_link_menu.f0bfab91.svg";